<template>
    <modal
        v-if="show"
        :type="'is-primary'"
        :size="'is-small'"
        :title="'Trial Limit Reached'"
        :submit-classes="{ 'is-primary': true, 'is-hidden': isMember }"
        :submit-text="'Upgrade'"
        :cancel-text="'Cancel'"
        @closed="handleClose"
        @submit="handleSubmit"
    >
        <div class="wrap">
            <form-message type="is-danger" icon="info-circle" :message="message" />
        </div>
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        show() {
            return this.trialLimitReachedShow;
        },

        ...mapState(stores.TrialLimitReachedModalModule, [
            'trialLimitReachedShow',
            'trialLimitReachedShowInboxesFlow',
        ]),
        ...mapState(stores.User, ['user']),

        isMember() {
            return (
                this.user.role === 'member' ||
                this.user.role === 'view_only' ||
                this.user.role === 'manager'
            );
        },

        message() {
            if (this.trialLimitReachedShowInboxesFlow) {
                return 'You have reached the limit of Inboxes on Trial. Please contact your admin to upgrade and create new Inboxes.';
            }

            return this.isMember
                ? 'You have reached the limit of 10 conversations. Please contact your admin to upgrade and begin new chats.'
                : 'You have reached the limit of 10 conversations. Upgrade to begin new chats.';
        },
    },

    methods: {
        handleSubmit() {
            this.$store.dispatch('showUpgradePlanTrialModal', true);
            this.$store.dispatch('showTrialLimitReachedModal', { show: false });
        },

        handleClose() {
            this.$store.dispatch('showTrialLimitReachedModal', { show: false });
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'styles.module.scss';
</style>
